import {register, CloudObject, defineProperty, Query, Predicate} from 'olympe';
import {Languages} from "./TranslatedString";

export const StringIDs = {
    ANNOTATION: 'annotation',
    ASSES_RESULT: 'assessment_result',
    INTRODUCTION: 'introduction',
    CONCLUSION: 'conclusion',
    PICTURE: 'picture',
    DEFECT_RATE: 'defect_rate',
    RESULT: 'result',
};

/**
 * @param {string} language
 * @param {...string} ids
 * @return {string}
 */
export const buildString = (language, ...ids) => {
    return ids.reduce((result, id) => {
        const item = Query.instancesOf(StaticTranslatedString)
            .filter(Predicate.equals(StaticTranslatedString._0IDProp, id))
            .executeFromCache()
            .getFirst();

        let value;
        switch (language) {
            case Languages.EN: value = item?.get(StaticTranslatedString.enProp); break;
            case Languages.DE: value = item?.get(StaticTranslatedString.deProp); break;
            case Languages.FR: value = item?.get(StaticTranslatedString.frProp); break;
            case Languages.IT: value = item?.get(StaticTranslatedString.itProp); break;
            case Languages.ZH: value = item?.get(StaticTranslatedString.zhProp); break;
            case Languages.ES: value = item?.get(StaticTranslatedString.esProp); break;
            case Languages.PT: value = item?.get(StaticTranslatedString.ptProp); break;
            case Languages.VI: value = item?.get(StaticTranslatedString.viProp); break;
            case Languages.TR: value = item?.get(StaticTranslatedString.trProp); break;
            default: value = item?.get(StaticTranslatedString.enProp);
        }
        value ??= item?.get(StaticTranslatedString.enProp);
        value && result.push(value)
        return result;
    }, []).join(' ');
};

/**
 * @extends {CloudObject}
 */
export default class StaticTranslatedString extends CloudObject { /* empty */ }

// Hardcoded tags
register('018a9820c81e5d2de998', StaticTranslatedString);
StaticTranslatedString._0IDProp = defineProperty('018a9821cab38ad53c18');
StaticTranslatedString.enProp = defineProperty('018a9821dd4e7f6c8f02');
StaticTranslatedString.deProp = defineProperty('018a9821ed3c0f6ca8ea');
StaticTranslatedString.frProp = defineProperty('018a9821f1e9f5c54ab6');
StaticTranslatedString.itProp = defineProperty('018a9821f66c5b517e5b');
StaticTranslatedString.ptProp = defineProperty('018a9821fa8c5c325fb9');
StaticTranslatedString.zhProp = defineProperty('018a9821fee1a0e804f7');
StaticTranslatedString.trProp = defineProperty('018a98220353cb8b04a7');
StaticTranslatedString.esProp = defineProperty('018a98220796961df1a1');
StaticTranslatedString.viProp = defineProperty('018a98220c4aff49bc8b');
